import { render } from "./CreditGroupComponent.vue?vue&type=template&id=2be54f1d"
import script from "./CreditGroupComponent.vue?vue&type=script&lang=js"
export * from "./CreditGroupComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__